// eslint-disable-next-line import/prefer-default-export
export function walk(graph, fn) {
  if (!graph) return null;
  const root = fn(graph);
  return {
    ...root,
    children: root?.children?.map((node) => walk(node, fn)),
  };
}
